<template>
    <div class="mb-5">
        <div class="row">
            <div class="col-5 text-center">
                <input
                    type="number"
                    pattern="[0-9]*"
                    class="form-control form-control-lg text-center input-score"
                    v-model="partido.marcadorlocal"
                />
            </div>
            <div class="col-2"></div>
            <div class="col-5 text-center">
                <input
                    type="number"
                    pattern="[0-9]*"
                    class="form-control form-control-lg text-center input-score"
                    v-model="partido.marcadorvisitante"
                />
            </div>
            <div class="w-100"></div>
            <div class="col-5 text-center">
                {{ partido.local.nombre }}
            </div>
            <div class="col-2 text-center">vs</div>
            <div class="col-5 text-center">
                {{ partido.visitante.nombre }}
            </div>
            <div class="w-100"></div>
        </div>
        <div v-if="!processing" class="row">
            <div class="col-12 col-boton">
                <button
                    class="btn btn-block btn-primary btn-save"
                    @click="guardar()"
                >
                    Guardar score
                </button>
            </div>
            <div class="col-4 col-boton">
                <button
                    class="btn btn-block btn-sm btn-danger btn-finalizar disabled"
                    @click="push('mediotiempo')"
                >
                    ½ Tiempo
                </button>
            </div>
            <div class="col-4 col-boton">
                <button
                    class="btn btn-block btn-sm btn-danger btn-finalizar disabled"
                    @click="push('segundotiempo')"
                >
                    Segundo
                </button>
            </div>
            <div class="col-4 col-boton">
                <button
                    class="btn btn-block btn-sm btn-danger btn-finalizar"
                    @click="push('finalizar')"
                >
                    Fin
                </button>
            </div>
        </div>
        <div v-else class="text-center div-botones">
            <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
        </div>
        <div class="clearfix"></div>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data() {
        return {
            processing: false,
        };
    },
    props: {
        partido: null,
        live: null,
    },
    methods: {
        guardar() {
            this.processing = true;
            axios
                .post("/partidos", {
                    partidoid: this.partido.partidoid,
                    marcadorlocal: this.partido.marcadorlocal,
                    marcadorvisitante: this.partido.marcadorvisitante,
                    live: this.live,
                })
                .then((response) => {
                    this.processing = false;
                })
                .catch((error) => {
                    this.processing = false;
                    alert(error);
                });
        },
        push(accion) {
            this.$swal({
                title: "¿Estás seguro?",
                text: "Esto envía push a todos los usuarios",
                icon: "warning",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonText: "Si",
                cancelButtonText: "Cancelar",
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.processing = true;
                        axios
                            .patch("partidos/" + this.partido.partidoid, {
                                accion: accion,
                            })
                            .then((response) => {
                                this.processing = false;
                            })
                            .catch((error) => {
                                this.processing = false;
                                alert(error);
                            });
                    }
                })
                .catch((error) => {
                    this.processing = false;
                    alert(error);
                });
        },
    },
};
</script>
<style scoped>
.div-botones {
    margin-top: 5px;
}
.col-boton {
    padding-right: 3px;
    padding-left: 3px;
    margin-top: 5px;
}
.input-score {
    font-size: 25px;
    height: 50px;
}
</style>
